import * as React from "react";
import { Multiselect } from "multiselect-react-dropdown";
import ColourComponent from "./ColourComponent";
import { isMobileOnly } from 'react-device-detect';
import { getProductsByColorMap, getColorIds, getColorConfig } from '../config-helper';
import { checkProductIncludeColours, checkProductIncludeSizes, 
    checkProductIncludeAccessories, isValidPostCodeOrSuburb, setFormLabelForItems, 
    getCountryCode } from '../common-utils'
import { raiseGAEvent, GA_EVENTS } from '../analytics';

// TODO: Need to be a separate component
const SelectModalMobile = props  => {
  return (
      <div>
          <div id="mobile-modal" className="store-select_modal-dialog">
              <div className="store-select_modal-body">
                  <div className="store-select_modal-heading-title">
                      {props.title}
                  </div>
                  {props.items.map((el) => {
                    const isChecked = props.isChecked(el.product_id);
                    return (
                        <div className={`store-select_modal-list ${isChecked ? 'store-select_modal-active-selections' : ''}`}  onClick={() => props.clickItem(el)} key={el.product_id}>
                            <input className="store_select_checkbox" type="checkbox" id={el.product_id} checked={isChecked} onClick={() => props.clickItem(el)} />
                            <label htmlFor="styled-checkbox-1"><span className="store_select_checkbox_items">{el.product_item_list_desc}</span></label>
                        </div>
                    );
                  })}
                  <div className="store-select_modal-list">
                      <button className="button button--state-search" onClick={() => props.handleApply(true)}>APPLY</button>
                  </div>
              </div>
          </div>
      </div>
    );
};

class FormComponent extends React.Component {
  constructor(props) {
    super(props);
    
    const { selectedColor, selectedSizes, selectedAccessories, postCode, selectedColourId } = this.props;

    this.state = {
      selectedColor,
      sizes: [],
      selectedSizes,
      accessories: [],
      selectedAccessories,
      postCode,
      errorMessage: "",
      superGroup: '',
      colourIds: [],
      colours: null,
      selectedColourId,
      productData:'',
      selectSize:false,
      selectAccessories:false,
      showSizeDropDown: false,
      showAccessoriesDropDown: false,
      isGrouped: true,
      isInvalidForm: false,
      sizeErrorClass: '',
      postCodeErrorClass: '',
      postCodeErrorMessage: '',
      sizeErrorMessage: '',
    };

    this.refSizeDesktopMultiSelect = React.createRef();
  }

  componentDidMount() {
    const {initialDOMState, sizes, accessories} = this.props;
    const firstColorId = getColorIds(initialDOMState)[0];
    const _this = this;
    
   
    this.setState({
      colourIds: getColorIds(initialDOMState),
      colours: getColorConfig(initialDOMState),
      productsWithColourMap: getProductsByColorMap(initialDOMState),
      initialDOMState,
      sizes: sizes ? sizes : [],
      accessories: accessories ? accessories : [],
      superGroup: initialDOMState.superGroup ? initialDOMState.superGroup : '',
      productData: JSON.parse(initialDOMState.groupedProductData),
      isGrouped: initialDOMState.isGrouped
    }, () => {
      this.setFirstColor(firstColorId, initialDOMState);
    });
    
    window.onclick = function(event) {
      const modal = document.getElementById("mobile-modal");
      if(event.target === modal) {
        _this.hideSelectSize();
        _this.hideSelectAccessories();
      }
    };
  }

  setFirstColor = (colorId, initialDOMState) =>{
    const {showStoreAvailabilitySearchButton} = this.props;
    if (!initialDOMState.isGrouped) return;
    if (this.state.colours !== null && showStoreAvailabilitySearchButton) {
      this.setState({
        selectedColor: this.getSelectedColourLabel(colorId)
      });
      const firstColor = this.state.colours[colorId].value;
      this.setColor(firstColor, colorId);
    }
  }
  
  componentDidUpdate(prevProps, prevState) {
    const {selectedColourId, selectedSizes, sizes} = this.state;
    if (prevState.selectedColourId !== selectedColourId) {
      this.setState({selectedAccessories:[], selectedSizes:[]});
    }
    
    if(!(selectedSizes.length > 0) && (sizes && sizes.length === 1)) {
      const formState = this.state;
      formState.selectedSizes = [sizes[0]];
      this.setState({formState});
    }
    
    let accessoriesMultiSelect = document.getElementById('accessories_input');
    if (accessoriesMultiSelect) {
      accessoriesMultiSelect.addEventListener("focus", this.onClickAccessories);
      accessoriesMultiSelect.addEventListener("focusout", this.closeAccessoriesDropDown);
    }
    
    const sizeInputElement = document.getElementById('size_input');
    if (sizeInputElement) {
      sizeInputElement.addEventListener('focus', this.onClickSize);
      sizeInputElement.addEventListener('focusout', this.closeSizeDropDown);
    }
  }
  
  onClickSize = () => {
    this.setState({
      showSizeDropDown: true
    });
    let dropdownIcon = document.getElementById('size').getElementsByTagName('div')[0];
    dropdownIcon.classList.add('hide-iocn');
  }
  
  onClickAccessories = () => {
    this.setState({
      showAccessoriesDropDown: true
    });
    let dropdownIcon = document.getElementById( 'accessories' ).getElementsByTagName( 'div' )[0];
    dropdownIcon.classList.add('hide-iocn');
  }
  
  closeSizeDropDown = () => {
    let element = document.getElementsByClassName("optionListContainer")[0];
    element.classList.add("_1YkOwrSkIvJIAvNNRNP3P5");
    
    let dropdownIcon = document.getElementById( 'size' ).getElementsByTagName( 'div' )[0];
    dropdownIcon.classList.remove('hide-iocn');
    
    this.setState({
      showSizeDropDown: false
    });

    this.refSizeDesktopMultiSelect.current.blur();
  }
  
  closeAccessoriesDropDown = () => {
    let element = document.getElementsByClassName("optionListContainer")[1];
    element.classList.add("_1YkOwrSkIvJIAvNNRNP3P5");
    
    let dropdownIcon = document.getElementById( 'accessories' ).getElementsByTagName( 'div' )[0];
    dropdownIcon.classList.remove('hide-iocn');
    
    this.setState({
      showAccessoriesDropDown: false
    });
  }
  
  getSelectedColourLabel = (colourId) => {
    return this.state.productsWithColourMap[colourId].label;          
  }
  
  setColor = (color, colourId) => {
    this.setState({
      selectedColor: this.getSelectedColourLabel(colourId),
      selectedColourId: colourId,
      sizes: this.state.productData[colourId].items ? this.state.productData[colourId].items.items : [],
      selectedSizes: [],
      accessories: this.state.productData[colourId].accessories ? this.state.productData[colourId].accessories.items : [],
    });
  }
  
  setSize = (selectedList, selectedItem) => {
    this.setState({
      selectedSizes: selectedList,
      sizeErrorMessage: ''
    });
    let element = document.getElementById('size').querySelectorAll("div");
    element[0].classList.remove("bbnt-findinstore__field--error");
    this.getSelectedSizes(selectedList);
    this.closeSizeDropDown();
  }

  setAccessories = (selectedList, selectedItem) => {
    this.setState({
      selectedAccessories: selectedList,
    });
  }

  setPostCode = (event) => {
    this.setState({ 
      postCode: event.target.value,
      postCodeErrorClass:'',
      postCodeErrorMessage:''
    });
  }

  callSearchButton = () => {
    const isValidForm = this.handleValidation();
    if (isValidForm) {
      const {postCode, selectedColor, selectedSizes, selectedAccessories, selectedColourId } = this.state;
      const sizes = selectedSizes.map(x => `size : ${x.product_item_list_desc} | product id : ${x.product_id}|`);
      raiseGAEvent(GA_EVENTS.CLICK_SEARCH_STORE_AVAILABILITY, sizes.join(','));
      this.props.onFormSubmit(postCode, selectedColor, selectedSizes, selectedAccessories, selectedColourId);
    } 
    else {
      this.setState({
        isInvalidForm: true,
      });
    }
  }
  
  searchAgain = () => {
    const isValidForm = this.handleValidation();
    if (isValidForm) {
      const { postCode, selectedColor, selectedSizes, selectedAccessories, selectedColourId } = this.state;
      this.props.handleShowSearch(postCode, selectedColor, selectedSizes, selectedAccessories, selectedColourId);
    } 
    else {
      this.setState({ isInvalidForm: true });
    }
  }

  handleValidation() {
    const { sizes, selectedSizes, postCode, superGroup, isGrouped} = this.state;
    let isValidSize = true;
    let isValidPostCode = true;

    if (isGrouped && checkProductIncludeSizes(superGroup) && superGroup && (sizes.length > 1)) {
      if (!selectedSizes || selectedSizes.length === 0) {
        isValidSize = false;
        this.setState({
          sizeErrorClass: 'bbnt-findinstore__field--error',
          sizeErrorMessage:'This field is required'
        });
        
        if (!isMobileOnly && document.getElementById('size') !== null) {
           let element = document.getElementById('size').querySelectorAll("div");
           element[0].classList.add("bbnt-findinstore__field--error"); 
        }
      }
    }

    if (!postCode || postCode === "") {
      isValidPostCode = false;
      isValidSize = true;
      this.setState({
        postCodeErrorClass:'bbnt-findinstore__field--error',
        postCodeErrorMessage: 'This field is required'
      });
    }
    else {
      const countryCode = getCountryCode();
      isValidPostCode = isValidPostCodeOrSuburb(postCode, countryCode) ? true : false;
      if (!isValidPostCode) {
        this.setState({
          postCodeErrorClass:'bbnt-findinstore__field--error',
          postCodeErrorMessage: 'Please enter a valid postcode or suburb'
        });
      }
    }
    return isValidSize && isValidPostCode;
  }

  renderColourSelect = () => {
    const { colours, colourIds, selectedColourId, selectedColor } = this.state;
    const handleColorSelect = this.setColor;
    
    if (this.isRenderColour(colours)) {
      return (
        <div className="field">
          <div className="form-header-labels">
            <label className="label">Colour: {selectedColor}</label>
          </div>
          <div className="color-section">
            {colourIds.map((keyName) => {
              return (
                <ColourComponent
                  isSelected={(selectedColourId == keyName)}
                  key={keyName}
                  colorId={keyName}
                  colorHex={colours[keyName].value}
                  handleColorSelect={handleColorSelect}
                />
              );
            })}
          </div>
        </div>
      );
    }

    return null;
  }
  
  getSelectedSizes = (selectedList) => {
  
    if(selectedList.length > 0){
      const labels = selectedList.map(i => i.product_item_list_desc).join(', ');
      const selectionLabel = (selectedList.length > 1) ? 'Selections' : 'Selection';
      return  `${selectedList.length} ${selectionLabel} (${labels})`;
      
    }
    return "Choose the sizes you want to find in store";
  }
  
  getSelectedAccessories = (selectedList) => {
    if (selectedList && selectedList.length > 0) {
      const labels = selectedList.map(i => i.product_item_list_desc).join(', ');
      const selectionLabel = (selectedList.length > 1) ? 'Selections' : 'Selection';
      return  `${selectedList.length} ${selectionLabel} (${labels})`;
    }
    
    return "Choose the pillowcases you want to find in store";
  }
  
  // Select box components for mobile view
  onClickMobileList = (item) => {
    const sizes = this.state.selectedSizes || [];
    let selectedList = [];
    const size = sizes ? sizes.find((el) => el.product_id === item.product_id) : '';
    if (size && size != '') {
      selectedList = sizes.filter((size)=>size.product_id !== item.product_id);
    }
    else {
      selectedList = [...sizes, item];
    }

    this.setState({ selectedSizes: selectedList });
  }

  setSizeMobile = (set) => {
    const selectedList = this.state.selectedSizes ? this.state.selectedSizes : [];
    if (set) {
      this.setState({ selectSize:false });
    }
    
    if (selectedList.length > 0) {
      const labels = selectedList.map(i => i.product_item_list_desc).join(', ');
      const selectionLabel = (selectedList.length > 1) ? 'Selections' : 'Selection';
      return  `${selectedList.length} ${selectionLabel} (${labels})`;
    }
    
    return 'Choose the sizes you want to find in store';
  }

  isRenderingSizesAsPlaceholder = () => {
    const selectedList = this.state.selectedSizes;
    return (selectedList && selectedList.length > 0);
  }

  isRenderingAccessoriesAsPlaceholder = () => {
    const selectedList = this.state.selectedAccessories;
    return (selectedList && selectedList.length > 0);
  };

  showSelectSize = () => {
    const {sizes} = this.props;
    if (sizes && sizes.length > 1){
      this.setState({ selectSize: true, sizeErrorClass:'', sizeErrorMessage:'' });
    } 
    else {
      this.setState({ selectSize: false});
    }
  }
  
  hideSelectSize = () => {
    this.setState({ selectSize: false});
  }
  
  hideSelectAccessories = () => {
    this.setState({ selectAccessories: false});
  }
  
  isChecked = (id) => {
    const selectedSizes = this.state.selectedSizes ? this.state.selectedSizes : [];
    if (selectedSizes.length > 0) {
      const size = this.state.selectedSizes.find((el) => el.product_id === id);
      if (size) {
        return true;
      }
      else return false;
    }
    else return false;
  }
  
  onClickMobilAccessoriesList = (item) => {
    const accessoryList = this.state.selectedAccessories;
    const accessories = accessoryList ? accessoryList.find((el) => el.product_id === item.product_id) : '';
    if (accessories) {
      const selectedAccessories = accessoryList.filter((el)=>el.product_id !== item.product_id);
      const selectedList = selectedAccessories ? selectedAccessories : [];
      this.setState({selectedAccessories : selectedList});
    }
    else {
      const selectedAccessories = accessoryList ? accessoryList : [];
      this.setState({selectedAccessories:[...selectedAccessories, item]});
    }
  }

  setAccessoriesMobile= (set) => {
    const selectedList = this.state.selectedAccessories ? this.state.selectedAccessories : [] ;
    if (set) {
      this.setState({selectAccessories:false});
    }
    if (selectedList.length > 0) {
      const labels = selectedList.map(i => i.product_item_list_desc).join(',');
      if (selectedList.length > 1) {
        return selectedList.length +" Selections ("+labels+")";
      } 
      else {
        return selectedList.length +" Selection ("+labels+")";
      }
    }
    return "Choose the pillowcases you want to find in store";
  }

  showSelectAccessories = () => {
    this.setState({selectAccessories:true});
  }
  
  isCheckedAccessories = (id) => {
    const selectedAccessories = this.state.selectedAccessories ? this.state.selectedAccessories : [];
    if (selectedAccessories.length > 0) {
      const size = this.state.selectedAccessories.find((el) => el.product_id === id);
      if (size) {
        return true;
      }
      else return false;
    }
    else return false;
  }
  
  // ---- end of mobile select box functions ----- 
  isRenderSizes = () => {
    const { sizes } = this.state;
    return (sizes && sizes.length > 0);
  }
  
  isRenderAccessories = () => {
    const { accessories } = this.props;
    return (accessories && accessories.length > 0);
  }
  
  isRenderColour = (colours) => {
    return (colours && (Object.keys(colours).length > 0));
  }
  
  renderSizes = () => {
    if (this.isRenderSizes()) {
      const { showSizeDropDown, sizeErrorMessage, superGroup, sizes} = this.state;

      return (
        <div className="field">
          <div className="form-header-labels">
            <label className="label">
              {setFormLabelForItems(superGroup)} *<br />
            </label>
          </div>
           {!isMobileOnly &&
              <div className={`${this.isRenderingSizesAsPlaceholder() ? "bbnt-find-in-store-modal-multiselect-container-values-as-placeholder" : 'bbnt-find-in-store-modal-desktop-multiselect-container-placeholder-as-placeholder'} ${showSizeDropDown ? "bbnt-find-in-store-modal-multiselect-container-show-close" : "bbnt-find-in-store-modal-multiselect-container-hide-close"}`}>
                { sizes.length === 1 ? <input type="text" value={"1 Selection ("+sizes[0].product_item_list_desc+")"} readOnly></input> :
                  this.renderDesktopMultiSelect(sizes, this.setSize, this.getSelectedSizes(this.state.selectedSizes), this.state.selectedSizes, "size")}
                {
                  showSizeDropDown &&
                  <label className="label--state-close" onClick={this.closeSizeDropDown}>Close</label>
                }
              </div>}
            {isMobileOnly &&
              this.renderMobileMultiSelect(sizes, this.showSelectSize, this.setSizeMobile(), this.state.selectSize, this.setSizeMobile, this.onClickMobileList, this.isChecked, setFormLabelForItems(superGroup) === "Sizes" ? "SELECT SIZES": "SELECT ITEMS", this.isRenderingSizesAsPlaceholder())
            }
            <div className="bbnt-findinstore__field--errorMessage">{sizeErrorMessage}</div>
        </div>
      );
    }
    return null;
  }
  
  renderDesktopMultiSelect = (options, onSelectAndRemove, setPlaceholder, selectedItems, id) => {
    return (
      <Multiselect
        ref={this.refSizeDesktopMultiSelect}
        options={options}
        displayValue="product_item_list_desc"
        showCheckbox={true}
        onSelect={onSelectAndRemove}
        onRemove={onSelectAndRemove}
        placeholder={setPlaceholder}
        selectedValues={selectedItems}
        avoidHighlightFirstOption={true}
        emptyRecordMsg= {true}
        closeOnSelect = {false}
        id={id}
      />
    );
  }

  renderMobileMultiSelect = (items, showSelectItems, setItemsMobile, selectItem, setItemMobile, onClickMobileList, isCheckedItems, title, isRenderingValuesAsPlaceholder) => {
    const {sizeErrorClass} = this.state;
    return(
     <div>
        <div className={`store-select_dropdown ${(title === "SELECT SIZES" || title === "SELECT ITEMS") ? sizeErrorClass : ''}`} 
          onClick={showSelectItems}>
          <input
            className={`input-text ${isRenderingValuesAsPlaceholder ? "values-as-placeholder" : "placeholder-as-placeholder"} store-select_input-box ${(title === "SELECT SIZES" || title === "SELECT ITEMS") ? sizeErrorClass : ''}`}
            type="text" value={setItemsMobile} disabled/>
        </div>
        
        { selectItem &&
          <SelectModalMobile 
            handleApply = {setItemMobile} clickItem = {onClickMobileList} items = {items}
            isChecked = {isCheckedItems} title = {title}
          /> 
        }
      </div>  
    );
  }
  
  renderAccessories = () => {
    if (this.isRenderAccessories()) {
      const { accessories, showAccessoriesDropDown } = this.state;
      return (
        <div className="field">
          <div className="form-header-labels">
            <label className="label">
              Pillowcases
              <br />
            </label>
          </div>
          <div>
            {!isMobileOnly &&
              <div className={`${this.isRenderingAccessoriesAsPlaceholder() ? "bbnt-find-in-store-modal-multiselect-container-values-as-placeholder" : 'bbnt-find-in-store-modal-desktop-multiselect-container-placeholder-as-placeholder'} ${showAccessoriesDropDown ? "bbnt-find-in-store-modal-multiselect-container-show-close" : "bbnt-find-in-store-modal-multiselect-container-hide-close"}`}>
                {
                  this.renderDesktopMultiSelect(accessories, this.setAccessories, this.getSelectedAccessories(this.state.selectedAccessories), this.state.selectedAccessories, "accessories")
                }
                {
                  showAccessoriesDropDown &&
                  <label className="label--state-close" onClick={this.closeAccessoriesDropDown}>Close</label>
                }
              </div>
            }
            {isMobileOnly &&
              this.renderMobileMultiSelect(accessories ? accessories : [], this.showSelectAccessories, this.setAccessoriesMobile(), this.state.selectAccessories, this.setAccessoriesMobile, this.onClickMobilAccessoriesList, this.isCheckedAccessories, "SELECT PILLOWCASES", this.isRenderingAccessoriesAsPlaceholder())
            }
          </div>
        </div>
      );
    }
    return null;
  }
  
  renderError = () => {
    const {isInvalidForm} = this.state;
    if (this.handleValidation) {
      return (isInvalidForm &&
        <>
          <br />
          <div id="findinstore-validation-message-box"><div className="mage-error">Some information is missing or incorrect. Please check the red fields for details.</div></div>
        </>);
    }
    return null;
  }

  renderSearchButton = () => {
    const {showStoreAvailabilitySearchButton} = this.props;
    if (showStoreAvailabilitySearchButton) {
      return (
          <button className="button button--state-search" onClick={this.callSearchButton}>SEARCH STORE AVAILABILITY</button>
      );
    }
    else {
      return (
        <button className="button button--state-search" onClick={this.searchAgain}>SEARCH AGAIN</button>
      );
    }
  }
  
  renderPostCode = () => {
    const { postCode, postCodeErrorClass, postCodeErrorMessage } = this.state;
    return (
      <div className="field">
        <div className="form-header-labels">
          <label className="label" htmlFor="postCode">Postcode or Suburb *</label>
        </div>
        <div>
          <input name="postCode" type="text" className={`bbnt-findinstore__field ${postCodeErrorClass}`}  
            placeholder="Enter your postcode or suburb" value={postCode || ''}
            onChange={this.setPostCode}
          />
          <div className="bbnt-findinstore__field--errorMessage">{postCodeErrorMessage}</div>
        </div>
      </div>  
    );
  }

  render() {
    return (
      <div className="form">
        <form className="form">
          {this.renderColourSelect()}
          {this.renderSizes()}
          {this.renderAccessories()}
          {this.renderPostCode()}
        </form>
        {this.renderError()}
        <br />
        {this.renderSearchButton()}
      </div>
    );
  }
}

FormComponent.propTypes = {};

export default FormComponent;
